// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-design-icon[data-v-4118d86a]{width:var(--default-clickable-area)}.list-item__wrapper--active .material-design-icon[data-v-4118d86a]{color:var(--color-primary-element-text) !important}`, "",{"version":3,"sources":["webpack://./src/components/NoteItem.vue"],"names":[],"mappings":"AACA,uCACC,mCAAA,CACA,mEACC,kDAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
